const locale = localStorage.getItem('_locale') || 'en';
const IntlReducer = (state = { locale: locale }, action ) => {
    if(action.type === "UPDATE_INTL"){
        return action.Intl 
    }
    return state
}
export default IntlReducer
